(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[158],{

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "3cys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/widgets/product-introduction-actions/ProductIntroductionActions.jsx
var ProductIntroductionActions = __webpack_require__("6Jj1");

// EXTERNAL MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx + 1 modules
var ProductLogo = __webpack_require__("hA0C");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction/ProductIntroduction.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductIntroduction_ProductIntroduction = function ProductIntroduction(_ref) {
  var className = _ref.className,
      iconName = _ref.iconName,
      isExclusiveCollection = _ref.isExclusiveCollection,
      imageSrc = _ref.imageSrc,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      ratingImage = _ref.ratingImage,
      reduceLabel = _ref.reduceLabel,
      seasonLink = _ref.seasonLink,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      title = _ref.title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!title) {
    return null;
  }

  var seeMoreSize = isDesktop ? 120 : 90;

  var top = __jsx("div", {
    className: "bg-white inset-x-0 mx-auto p-15 pt-20 rounded-12 shadow-subtle z-1",
    style: _objectSpread({}, isDesktop ? {
      width: 'calc(180rem / 16)',
      position: 'absolute',
      top: 'calc(-60rem / 16)'
    } : {
      marginBottom: 'calc(-100rem / 16)',
      position: 'relative',
      top: 'calc(-100rem / 16)',
      width: 'calc(160rem / 16)'
    })
  }, __jsx(ProductLogo["a" /* ProductLogo */], {
    className: "mb-30",
    iconName: iconName,
    isExclusiveCollection: isExclusiveCollection,
    productCountry: productCountry,
    productName: productName
  }), __jsx(ProductIntroductionActions["a" /* ProductIntroductionActions */], {
    ratingImage: ratingImage
  }));

  var seasonSwitch = seasonLink && seasonLink.url && __jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "font-bold inline-flex gap-10 items-center justify-center leading-1 p-15 rounded-extra shadow-subtle text-14 lg:text-16 text-black hocus:text-black-active transition-colors duration-250 ease-in",
    url: seasonLink.url,
    trackingData: {
      actionGA: 'blockInfos',
      labelGA: 'switchSeason'
    }
  }, __jsx(Icon["a" /* Icon */], {
    name: seasonLink.iconName,
    width: isDesktop ? 'calc(22rem / 16)' : 'calc(16rem / 16)'
  }), seasonLink.label);

  var content = __jsx(react["Fragment"], null, __jsx(Title["a" /* Title */], {
    className: "font-bold font-brand mb-20 text-28 md:text-44 leading-tight",
    theme: "none"
  }, Object(string_util["d" /* truncate */])(title, 50)), __jsx(TextSeeMore["a" /* TextSeeMore */], {
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: !isDesktop,
    seeLessLabel: reduceLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize,
    text: text,
    theme: "text-sans-n3"
  }));

  return isDesktop ? __jsx("article", {
    className: (className, 'isolate mt-60 pt-20 relative')
  }, top, __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: "overflow-hidden relative rounded-12 w-1/2 z-0"
  }, __jsx(Image["b" /* default */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["c" /* default */].R_63_BY_58,
    ratioDisplay: 1 / 2
  })), __jsx("div", {
    className: "flex py-60 items-center relative w-1/2"
  }, __jsx("div", {
    className: "absolute top-0 ltr:right-0 rtl:left-0"
  }, seasonSwitch), __jsx("div", {
    className: "ltr:ml-auto rtl:mr-auto ltr:pl-20 rtl:pr-20 w-5/6"
  }, content)))) : __jsx("article", {
    className: className
  }, __jsx("div", {
    className: "pt-20 mb-40"
  }, __jsx("div", {
    className: "mx-auto overflow-hidden",
    style: {
      maxWidth: 400,
      borderRadius: 'calc(10rem / 16)'
    }
  }, __jsx(Image["b" /* default */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["c" /* default */].SQUARE
  })), top, __jsx("div", {
    className: "flex justify-center pt-15"
  }, seasonSwitch)), content);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/InfoBannerContainer.jsx
var InfoBannerContainer = __webpack_require__("wgpp");

// CONCATENATED MODULE: ./src/client/components/lines/product-introduction-line/ProductIntroductionLine.jsx



var ProductIntroductionLine_jsx = react_default.a.createElement;







var ProductIntroductionLine_ProductIntroductionLine = function ProductIntroductionLine(_ref) {
  var config = _ref.config,
      hasSeasonButton = _ref.hasSeasonButton,
      hasTripadvisorButton = _ref.hasTripadvisorButton,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      resort = _ref.resort;
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);

  if (!config || !resort) {
    return null;
  }

  var descriptionTitle = resort.descriptionTitle,
      description = resort.description,
      country = resort.destination.country,
      icon = resort.icon,
      productId = resort.id,
      _resort$images = resort.images,
      images = _resort$images === void 0 ? [] : _resort$images,
      isDoubleSeason = resort.isDoubleSeason,
      isExclusiveCollection = resort.isExclusiveCollection,
      isWinter = resort.isWinter,
      linkedResort = resort.linkedResort,
      name = resort.name,
      _resort$tripadvisor = resort.tripadvisor,
      _resort$tripadvisor$r = _resort$tripadvisor.rating,
      rating = _resort$tripadvisor$r === void 0 ? '' : _resort$tripadvisor$r,
      _resort$tripadvisor$r2 = _resort$tripadvisor.ratingImageUrl,
      ratingImageUrl = _resort$tripadvisor$r2 === void 0 ? '' : _resort$tripadvisor$r2;
  var _config$common = config.common,
      loadLess = _config$common.loadLess,
      viewMore = _config$common.viewMore,
      _config$resort$resort = config.resort.resortIntroduction,
      toSummerLabel = _config$resort$resort.toSummerLabel,
      toWinterLabel = _config$resort$resort.toWinterLabel;
  var productIntroductionProps = {
    iconName: icon,
    imageSrc: imageSrc || images[2] || images[1] || images[0],
    productCountry: country,
    productName: name,
    ratingImage: hasTripadvisorButton ? {
      alt: "Tripadvisor: ".concat(rating),
      src: ratingImageUrl
    } : null,
    reduceLabel: loadLess,
    seasonLink: isDoubleSeason || !hasSeasonButton ? null : {
      iconName: isWinter ? icons["a" /* ICONS */].SUN : icons["a" /* ICONS */].MOUNTAIN,
      label: isWinter ? toSummerLabel : toWinterLabel,
      url: linkedResort && linkedResort.href
    },
    seeMoreLabel: viewMore,
    title: descriptionTitle,
    text: description,
    isExclusiveCollection: isExclusiveCollection
  };
  return ProductIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line pt-1",
    "data-testid": "resort-introduction",
    id: id,
    size: "large"
  }, ProductIntroductionLine_jsx(InfoBannerContainer["a" /* InfoBannerContainer */], {
    className: "pt-40 pb-20 lg:pt-20 lg:pb-40 z-1",
    contentClassName: "justify-center",
    departureDate: departureDate,
    duration: duration,
    popinPosition: "center",
    productId: productId,
    trackingData: {
      categoryGA: 'resort'
    }
  }), ProductIntroductionLine_jsx(ProductIntroduction_ProductIntroduction, productIntroductionProps));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-introduction/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductIntroductionLine_ProductIntroductionLine);

/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArrivalDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var arrivalDate = _ref5.arrivalDate;
  return arrivalDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinEmail = _ref6.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinSms = _ref7.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinMail = _ref8.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinPhone = _ref9.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref10) {
  var optinFosun = _ref10.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var duration = _ref11.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref12) {
  var flexibility = _ref12.flexibility;
  return flexibility;
});


/***/ }),

/***/ "UpHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getInfoBannerQuery; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ infoBanner_utils_renderInfoBanner; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/capitalize.js
var capitalize = __webpack_require__("h++M");
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/InfoBanner.themes.js
var InfoBanner_themes = __webpack_require__("cN29");

// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/InfoBanner.jsx













var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var positions = {
  left: 'ltr:left-0 rtl:right-0',
  right: 'ltr:right-0 rtl:left-0',
  center: 'inset-x-0'
};
var InfoBanner_InfoBanner = function InfoBanner(_ref) {
  var className = _ref.className,
      contentClassName = _ref.contentClassName,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
      _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === void 0 ? {
    width: 'calc(774rem / 16)'
  } : _ref$containerStyle,
      countdown = _ref.countdown,
      iconName = _ref.iconName,
      illustration = _ref.illustration,
      popin = _ref.popin,
      _ref$popinPosition = _ref.popinPosition,
      popinPosition = _ref$popinPosition === void 0 ? 'left' : _ref$popinPosition,
      subtitle = _ref.subtitle,
      title = _ref.title,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData;
  var track = Object(useTracking["a" /* useTracking */])(trackingData || {});
  var trackBtnClick = !isEmpty_default()(trackingData) ? track : noop_default.a;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var hasModal = !!popin && (!!(popin === null || popin === void 0 ? void 0 : popin.title) || !!(popin === null || popin === void 0 ? void 0 : popin.text) || !!(popin === null || popin === void 0 ? void 0 : popin.subtitle));
  var hasCountdown = !isEmpty_default()(countdown) && countdown.dateTimeEnd;
  var hasIcon = Boolean(illustration || iconName);
  var _themes$theme = Object(InfoBanner_themes["a" /* themes */])({
    color: color
  })[theme],
      thDescriptionBloc = _themes$theme.thDescriptionBloc,
      thPopinContent = _themes$theme.thPopinContent,
      thPopinContentImage = _themes$theme.thPopinContentImage,
      thPopinColor = _themes$theme.thPopinColor,
      thPopinTextColor = _themes$theme.thPopinTextColor;

  if (!title && !subtitle && !hasIcon && !hasCountdown) {
    return null;
  }

  var content = __jsx("div", {
    className: classnames_default()('flex text-initial', contentClassName)
  }, hasIcon && __jsx("div", {
    className: "border-".concat(color, " border-1 h-[56px] shrink-0 overflow-hidden rounded-5")
  }, illustration ? __jsx("img", {
    alt: "",
    className: "h-full",
    src: illustration
  }) : __jsx(Icon["a" /* Icon */], {
    className: "p-5",
    color: color,
    name: iconName,
    width: "calc(56rem / 16)"
  })), hasCountdown && __jsx("div", {
    className: "bg-white border-".concat(color, " border-1 flex flex-col h-[56px] grow sm:grow-0 items-center justify-center sm:order-1 overflow-hidden rounded-5 text-").concat(color)
  }, __jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    dateTimeEnd: countdown === null || countdown === void 0 ? void 0 : countdown.dateTimeEnd,
    theme: "infoBanner"
  }))), (title || subtitle) && __jsx("div", {
    className: classnames_default()(thDescriptionBloc, 'h-[56px]')
  }, __jsx("h6", {
    className: "text-10"
  }, subtitle), __jsx("h5", {
    className: "font-brand font-normal text-16 underline"
  }, title)));

  var imageProps = isDesktop ? {
    dimensions: {
      w: 300,
      h: 170
    }
  } : {
    dontChangeAnything: true
  };
  var tooltipContent = hasModal ? __jsx("div", {
    className: thPopinContent
  }, (popin === null || popin === void 0 ? void 0 : popin.image) && __jsx("div", {
    className: thPopinContentImage,
    style: isDesktop ? {
      height: '220px'
    } : {}
  }, __jsx(Image["a" /* Image */], Object(esm_extends["a" /* default */])({
    className: "h-full overflow-hidden rounded",
    imageUrl: popin.image
  }, imageProps))), __jsx("div", {
    className: "p-20"
  }, (popin === null || popin === void 0 ? void 0 : popin.title) && __jsx(Text["a" /* Text */], {
    className: "font-brand font-normal leading-tight text-24 text-".concat(thPopinColor),
    hLevel: 3,
    text: popin.title,
    theme: "none"
  }), (popin === null || popin === void 0 ? void 0 : popin.subtitle) && __jsx(Text["a" /* Text */], {
    className: "font-bold leading-tight text-14",
    hLevel: 4,
    text: popin.subtitle,
    theme: "none"
  }), (popin === null || popin === void 0 ? void 0 : popin.text) && __jsx(Text["a" /* Text */], {
    className: "py-10 leading-tight lg:leading-loose text-14",
    text: popin.text
  }), (popin === null || popin === void 0 ? void 0 : popin.url) && __jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({
    color: thPopinTextColor,
    colorBg: thPopinColor,
    url: popin.url
  }, trackingData ? {
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      actionGA: 'bannerInfo',
      labelGA: 'clickBannerInfo_link'
    })
  } : {}), popin.buttonLabel))) : null;
  var position = popinPosition === 'left' ? 'left' : 'right';
  return __jsx("div", {
    className: classnames_default()(className, 'isolate relative')
  }, hasModal ? __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: (popin === null || popin === void 0 ? void 0 : popin.title) ? popin.title : '',
    className: "flex justify-end",
    containerClassName: "z-3 border-1 border-".concat(color, " ").concat(positions[popinPosition]),
    containerStyle: containerStyle,
    contentClassName: "arrow-bg arrow-bg-".concat(color, " arrow-up").concat(capitalize_default()(position)),
    content: tooltipContent,
    hasCloseButton: true,
    onClick: function onClick() {
      return trackBtnClick({
        actionGA: 'bannerInfo',
        labelGA: 'clickBannerInfo'
      });
    },
    theme: "infoBanner"
  }, content) : content);
};
// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/infoBanner.utils.js













var infoBanner_utils_jsx = react["createElement"];

function infoBanner_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function infoBanner_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? infoBanner_utils_ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : infoBanner_utils_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getInfoBannerQuery = function getInfoBannerQuery(productId) {
  return "query {\n    productInformationBanners(productId:\"".concat(productId, "\") {\n        productId\n        salesChannel {\n          context\n          tags\n        }\n        countdown {\n          dateTimeEnd\n          daysLabel\n          hoursLabel\n          minutesLabel\n          secondsLabel\n        }\n        popin {\n          title\n          subtitle\n          text: description\n          buttonLabel\n          url\n          image\n          color\n        }\n        startDate\n        endDate\n        toaster {\n          title\n          subtitle: description\n          iconName\n          illustration: picto\n          color\n        }\n    }\n  }");
}; // eslint-disable-next-line clubmed/no-fake-component

var infoBanner_utils_renderInfoBanner = function renderInfoBanner(infoBannerData, appContext, departureDate, arrivalDate, currentStep, actionGA, containerStyle, theme, contentClassName, popinPosition) {
  var className = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 'mb-20 z-2';
  var currentCtxInfoBanner = 'B2C';

  if (appContext.isCmta) {
    currentCtxInfoBanner = 'CMTA';
  }

  if (appContext.isCxo) {
    currentCtxInfoBanner = 'CXO';
  }

  var content = ((infoBannerData === null || infoBannerData === void 0 ? void 0 : infoBannerData.productInformationBanners) || []).map(function (productInformationBanner, index) {
    var theContextInfoBannerData = productInformationBanner.salesChannel.find(function (el) {
      return el.context === currentCtxInfoBanner;
    });
    var isDepartureDateIncludedInBannerDates = moment_default()(departureDate).isBetween(Object(apiDate["h" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["h" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || moment_default()(arrivalDate).isBetween(Object(apiDate["h" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.startDate), Object(apiDate["h" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate), null, []) || Object(apiDate["h" /* momentFromApiDate */])(productInformationBanner === null || productInformationBanner === void 0 ? void 0 : productInformationBanner.endDate).isSame(arrivalDate);

    if (!theContextInfoBannerData || !isDepartureDateIncludedInBannerDates || !theContextInfoBannerData.tags.includes(currentStep)) {
      return null;
    }

    var countdown = productInformationBanner.countdown,
        popin = productInformationBanner.popin,
        toaster = productInformationBanner.toaster;
    var infoBannerCountdown = countdown ? infoBanner_utils_objectSpread(infoBanner_utils_objectSpread({}, countdown), {}, {
      dateTimeEnd: moment_default()(countdown.dateTimeEnd, 'YYYYMMDD HH:mm:ss'),
      days: Object(i18n["h" /* t */])('options.countdownLabels.days'),
      hours: Object(i18n["h" /* t */])('options.countdownLabels.hours'),
      minutes: Object(i18n["h" /* t */])('options.countdownLabels.minutes'),
      seconds: Object(i18n["h" /* t */])('options.countdownLabels.seconds')
    }) : null;
    return infoBanner_utils_jsx(InfoBanner_InfoBanner, Object(esm_extends["a" /* default */])({
      key: "infoBanner_".concat(index)
    }, toaster, {
      containerStyle: containerStyle,
      contentClassName: contentClassName,
      countdown: infoBannerCountdown,
      popin: popin,
      popinPosition: popinPosition,
      theme: theme,
      trackingData: infoBanner_utils_objectSpread({}, actionGA)
    }));
  }).filter(Boolean);

  if (!content.length) {
    return null;
  }

  return infoBanner_utils_jsx("div", {
    className: classnames_default()(className, 'flex flex-col sm:flex-row gap-10 isolate relative')
  }, content);
};

/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    dataTestId: "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after mb-20 rounded-2 shadow-md',
    thCloseButton: 'absolute p-5 ltr:right-0 rtl:left-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'w-full',
    thContainer: 'absolute top-full fadeIn mt-5 rounded-2',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-5 ltr:right-0 rtl:left-0 text-mediumGrey',
    thCloseIconWidth: '0.875rem'
  },
  priceOfStayTooltip: {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-white bg-white filter-drop-shadow-after mb-20 rounded-2',
    thCloseButton: 'absolute p-5 ltr:right-0 rtl:left-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  fancy: {
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-5',
    thContent: 'arrow-bg arrow-bg-black arrow-downLeft arrow-large arrow-white bg-white border-1 border-black filter-drop-shadow-after mb-20 rounded-12 shadow-md',
    thCloseButton: 'absolute leading-0 p-10 ltr:right-0 rtl:left-0 top-0 text-grey',
    thCloseIconWidth: '0.625rem'
  },
  favorite: {
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-40 flex justify-end',
    thContent: 'arrow-downRight arrow-white bg-white filter-drop-shadow-after text-12 mb-10 text-center rounded-2 shadow-bottomDiffuse',
    thCloseButton: 'absolute leading-none p-10 ltr:right-0 rtl:left-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  'favorite-centered': {
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-40 flex justify-center',
    thContent: 'arrow-down arrow-white bg-white filter-drop-shadow-after text-12 mb-10 text-center rounded-2 shadow-bottomDiffuse',
    thCloseButton: 'absolute leading-none p-10 ltr:right-0 rtl:left-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  typesOfStaySearchFilter: {
    thContainer: 'absolute bottom-full fadeIn -mb-5 w-screen',
    thContent: 'flex w-full leading-1',
    thCloseButton: '',
    thTrigger: 'leading-0',
    thCloseIconWidth: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      containerStyle = _ref.containerStyle,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _ref$isInitiallyVisib = _ref.isInitiallyVisible,
      isInitiallyVisible = _ref$isInitiallyVisib === void 0 ? false : _ref$isInitiallyVisib,
      _ref$isModalOnly = _ref.isModalOnly,
      isModalOnly = _ref$isModalOnly === void 0 ? false : _ref$isModalOnly,
      _onClick = _ref.onClick,
      onRender = _ref.onRender,
      onTimeout = _ref.onTimeout,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      timeoutInMs = _ref.timeoutInMs,
      triggerOnHover = _ref.triggerOnHover;

  var _useState = Object(react["useState"])(isInitiallyVisible),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(react["useEffect"])(function () {
    onRender && onRender();

    if (timeoutInMs && timeoutInMs > 0) {
      setTimeout(function () {
        setIsVisible(false);
        onTimeout && onTimeout();
      }, timeoutInMs);
    }

    return function () {
      onTimeout && onTimeout();
    };
  }, []);
  var shouldTriggerOnHover = triggerOnHover && isDesktop;
  Object(react["useEffect"])(function () {
    var timeoutId;

    if (shouldTriggerOnHover && isVisible && _onClick) {
      timeoutId = setTimeout(_onClick, 300);
      return function () {
        clearTimeout(timeoutId);
      };
    }
  }, [isVisible, shouldTriggerOnHover]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  return __jsx("div", Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'isolate relative')
  }, shouldTriggerOnHover && {
    onMouseEnter: function onMouseEnter(e) {
      setIsVisible(true);

      if (!shouldTriggerOnHover) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    },
    onMouseLeave: function onMouseLeave() {
      setIsVisible(false);
    }
  }), __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();

      if (!timeoutInMs) {
        setIsVisible(!isVisible);
      }

      if (!isVisible && !shouldTriggerOnHover && _onClick) {
        _onClick(e);
      }
    },
    type: "button"
  }, children), isVisible && (isDesktop && !isModalOnly ? __jsx(ClickOutside["a" /* ClickOutside */], Object(esm_extends["a" /* default */])({
    className: classnames_default()(thContainer, containerClassName),
    onClick: function onClick() {
      setIsVisible(false);
    }
  }, containerStyle ? {
    style: containerStyle
  } : {}), __jsx("div", {
    className: classnames_default()(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "cN29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var themes = function themes(_ref) {
  var color = _ref.color;
  var rColor = _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS_LIST */ "b"].includes(color) ? color : _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].TURQUOISE;
  var thDescriptionBloc = "bg-".concat(rColor, " px-5 flex flex-col grow sm:grow-0 justify-center ltr:pr-10 rtl:pl-10 rounded-5 text-").concat(_utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor], " w-auto");
  var thPopinContent = "border-1 border-".concat(rColor, " lg:border-0 flex flex-col");
  return {
    "default": {
      thDescriptionBloc: thDescriptionBloc,
      thPopinContent: "".concat(thPopinContent, " lg:flex-row"),
      thPopinContentImage: 'shrink-0 px-20 pt-20 lg:ltr:pl-20 lg:rtl:pr-20 lg:ltr:pr-0 lg:rtl:pl-0 lg:py-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    },
    comparator: {
      thDescriptionBloc: "".concat(thDescriptionBloc, " sm:w-full"),
      thPopinContent: thPopinContent,
      thPopinContentImage: 'shrink-0 lg:ltr:pl-10 lg:rtl:pr-10 lg:py-10 mt-15',
      thPopinColor: rColor,
      thPopinTextColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COMPLEMENTARY_COLORS */ "c"][rColor]
    }
  };
};

/***/ }),

/***/ "mmhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Countdown_Countdown; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__("Jhhs");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/memoize.js
var memoize = __webpack_require__("pFSi");
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.themes.js





var defaultValueSizes = {
  small: {
    w: '2.3rem',
    valueTextSize: 'text-16',
    labelTextSize: 'text-8'
  },
  large: {
    w: '3.0625rem',
    valueTextSize: 'text-24',
    labelTextSize: 'text-10'
  }
};
var themes = {
  "default": memoize_default()(function (_ref) {
    var size = _ref.size,
        color = _ref.color;
    var textColor = color ? color : colors["a" /* COLORS */].WHITE;
    var textShadow = textColor === colors["a" /* COLORS */].WHITE ? 'text-shadow-2' : '';
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thItem: "flex flex-col items-center justify-between mx-5 text-center text-".concat(textColor),
      thValuesWrapper: 'flex flex-row',
      thLabel: "font-bold leading-1 mb-5 ".concat(textShadow, " uppercase ").concat(defaultValueSizes[size].labelTextSize),
      thValue: "flex font-bold items-center justify-center rounded-5 text-center ".concat(textShadow, " leading-tight ").concat(defaultValueSizes[size].valueTextSize),
      thValueStyle: {
        width: defaultValueSizes[size].w
      }
    };
  }),
  timer: memoize_default()(function (_ref2) {
    var size = _ref2.size,
        color = _ref2.color;
    return {
      thRoot: 'flex items-stretch justify-center text-14 mb-15',
      thDescription: "bg-".concat(color, " text-white shadow-sm py-5 px-10 mr-10 items-baseline"),
      thItem: "flex flex-row items-center justify-between text-center text-".concat(color),
      thLabel: 'items-baseline',
      thValuesWrapper: 'flex flex-row shadow-sm py-5 px-10 w-[7.5rem] justify-center',
      thValue: 'flex items-center justify-center rounded-5 text-center pl-5',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  offerPush: function offerPush(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref3$color,
        bgColor = _ref3.bgColor;
    return {
      thRoot: classnames_default()("font-sans font-bold px-10 py-5 rounded-2 text-12 text-".concat(color), Object(defineProperty["a" /* default */])({}, "bg-".concat(bgColor), !!bgColor)),
      thItem: "inline mx-1 text-center text-".concat(color, " uppercase"),
      thValuesWrapper: 'flex flex-row py-1',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: 'auto'
      }
    };
  },
  infoBanner: function infoBanner() {
    return {
      thRoot: 'font-brand px-5 rounded-2',
      thItem: 'flex mx-1 text-center text-14 uppercase',
      thValuesWrapper: 'flex flex-row',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: '20px'
      }
    };
  },
  push: memoize_default()(function (_ref4) {
    var color = _ref4.color;
    return {
      thRoot: "font-brand text-".concat(color, " text-18 uppercase"),
      thValuesWrapper: 'flex',
      thItem: 'flex items-center leading-1 mx-2'
    };
  }),
  options: memoize_default()(function (_ref5) {
    var size = _ref5.size,
        color = _ref5.color;
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch mb-5',
      thDescription: 'font-bold text-saffron py-5 items-baseline',
      thItem: "flex flex-row items-baseline justify-between text-center text-".concat(color),
      thLabel: 'items-baseline text-14',
      thValuesWrapper: 'flex flex-row font-bold text-18 items-center',
      thValue: 'flex items-center justify-center rounded-5 text-center pl-5 text-18',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  optionDetails: memoize_default()(function (_ref6) {
    var size = _ref6.size,
        _ref6$color = _ref6.color,
        color = _ref6$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref6$color;
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thDescription: 'font-bold text-black py-5 items-baseline',
      thItem: "flex flex-col items-center text-".concat(color, " bg-pearl p-5 ml-5"),
      thLabel: 'items-baseline text-10 text-black',
      thValuesWrapper: 'flex flex-row font-bold text-18 items-center',
      thValue: 'flex items-center justify-center rounded-5 text-center pl-5 text-18',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  })
};
// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx







var __jsx = react_default.a.createElement;





function calculateTimeLeft(dateTimeEnd) {
  var now = moment_default()();
  return now.isBefore(dateTimeEnd) ? moment_default.a.duration(moment_default()(dateTimeEnd).diff(now)) : moment_default.a.duration(0);
}

function resolveTime(unit, roundToUnit, timeRemaining) {
  if (roundToUnit === unit) {
    switch (roundToUnit) {
      case 'days':
        return Math.floor(timeRemaining.asDays()).toString();

      case 'hours':
        return Math.floor(timeRemaining.asHours()).toString();

      case 'minutes':
        return Math.floor(timeRemaining.asMinutes()).toString();

      case 'seconds':
        return Math.floor(timeRemaining.asSeconds()).toString();

      default:
        return Math.floor(timeRemaining.asSeconds()).toString();
    }
  }

  return timeRemaining.get(unit).toString();
}

var Countdown_Countdown = function Countdown(_ref) {
  var bgColor = _ref.bgColor,
      className = _ref.className,
      color = _ref.color,
      dataTestId = _ref.dataTestId,
      dateTimeEnd = _ref.dateTimeEnd,
      description = _ref.description,
      expiredRender = _ref.expiredRender,
      _ref$roundToUnit = _ref.roundToUnit,
      roundToUnit = _ref$roundToUnit === void 0 ? 'days' : _ref$roundToUnit,
      _ref$showTimer = _ref.showTimer,
      showTimer = _ref$showTimer === void 0 ? true : _ref$showTimer,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$units = _ref.units,
      units = _ref$units === void 0 ? ['days', 'hours', 'minutes', 'seconds'] : _ref$units,
      _ref$updateFrequency = _ref.updateFrequency,
      updateFrequency = _ref$updateFrequency === void 0 ? 300 : _ref$updateFrequency,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["bgColor", "className", "color", "dataTestId", "dateTimeEnd", "description", "expiredRender", "roundToUnit", "showTimer", "size", "theme", "units", "updateFrequency"]);

  var _useState = Object(react["useState"])(calculateTimeLeft(dateTimeEnd)),
      timeRemaining = _useState[0],
      setTimeRemaining = _useState[1];

  Object(react["useEffect"])(function () {
    var timer = setTimeout(function () {
      if (dateTimeEnd && timeRemaining.asSeconds() > 0) {
        setTimeRemaining(calculateTimeLeft(dateTimeEnd));
      }
    }, updateFrequency);
    return function () {
      return clearTimeout(timer);
    };
  }, [timeRemaining, dateTimeEnd]);
  var shouldDisplay = timeRemaining.asSeconds() > 0 && timeRemaining.months() === 0;

  if (!shouldDisplay) {
    if (dateTimeEnd && !!expiredRender) {
      return expiredRender;
    }

    return null;
  }

  if (!showTimer) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    size: size,
    bgColor: bgColor
  }),
      thItem = _themes$theme.thItem,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thValue = _themes$theme.thValue,
      thDescription = _themes$theme.thDescription,
      thValueStyle = _themes$theme.thValueStyle,
      thValuesWrapper = _themes$theme.thValuesWrapper;

  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    role: "timer",
    "data-testid": dataTestId
  }, description && __jsx("div", {
    className: thDescription
  }, description), __jsx("div", {
    className: thValuesWrapper
  }, units.map(function (unit) {
    var currentTime = resolveTime(unit, roundToUnit, timeRemaining);
    var transformedCurrentTime = currentTime.padStart(2, '0');
    return __jsx("div", {
      className: thItem,
      key: unit
    }, __jsx("div", {
      className: thValue,
      style: thValueStyle
    }, transformedCurrentTime), __jsx("div", {
      className: thLabel
    }, " ", props[unit]));
  })));
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}



/***/ }),

/***/ "wgpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoBannerContainer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _infoBanner_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UpHs");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("EkOT");
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("CcNa");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("829J");
/* harmony import */ var _InfoBanner_themes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cN29");


var _pageMappings;










var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["b2cPagesService"].PAGE_TYPES;
var pageMappings = (_pageMappings = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_pageMappings, PAGE_TYPES.RESORT, 'resort_page'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_pageMappings, PAGE_TYPES.PLE, 'customer_area'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_pageMappings, _tracking_constants__WEBPACK_IMPORTED_MODULE_8__[/* STATIC_PAGE_TYPES */ "x"].SHOPPING_SEARCH, 'comparator'), _pageMappings);
var InfoBannerContainer = function InfoBannerContainer(_ref) {
  var className = _ref.className,
      contentClassName = _ref.contentClassName,
      departureDate = _ref.departureDate,
      duration = _ref.duration,
      popinPosition = _ref.popinPosition,
      containerStyle = _ref.containerStyle,
      productId = _ref.productId,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData;
  var appContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_5__[/* usePageContext */ "b"])();

  var _useGQL = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_6__[/* useGQL */ "a"])({
    query: Object(_infoBanner_utils__WEBPACK_IMPORTED_MODULE_4__[/* getInfoBannerQuery */ "a"])(productId),
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__[/* WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS */ "Gd"]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  var tripEndDate = departureDate && duration && moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add(duration, 'days').format('YYYY-MM-DD');
  return !isLoading && Object(_infoBanner_utils__WEBPACK_IMPORTED_MODULE_4__[/* renderInfoBanner */ "b"])(data, appContext, departureDate, tripEndDate, appContext.pageType && pageMappings[appContext.pageType], trackingData, containerStyle, theme, contentClassName, popinPosition, className);
};

/***/ })

}]);